import React from "react";
import useContactUs from "../../hooks/useContactUs";
import "./ContactUs.scss";
import ContactUsInfo from "./ContactUsInfo/ContactUsInfo";
import contactImg from "../../assets/About/rupali-building.png";

const ContactUs = () => {
  const [contactUs, setContactUs, loading] = useContactUs();
  // console.log("contact", contactUs);

  const { Address, EmailAdd, BusinessHour, InvestDeptInfo, ContactNo } =
    contactUs;

  let Info = "";
  //   let info1 = Info[0];
  //   console.log("Typeof ins ", typeof InvestDeptInfo);
  if (InvestDeptInfo) {
    Info = InvestDeptInfo.split("<br/>");
    // console.log(Info);
  }

  return (
    <>
      <div className="container">
        <div className="contact_us">
          <div className="heading_box">Contact Us</div>

          {loading ? (
            <div className="contact_us_content">
              <div className="row justify-content-between">
                <div className="col-lg-6 left my-auto">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <i className="fa-solid fa-house-flag"></i>
                      <h4>Address</h4>
                      <p>{Address}</p>
                    </div>

                    <div className="col-md-6 mb-3">
                      <i className="fa-solid fa-clock"></i>
                      <h4>Business Hours</h4>
                      <p>{BusinessHour}</p>
                    </div>

                    <div className="row my-4">
                      <div className="col-md-6 mb-3">
                        <i className="fa-solid fa-phone-volume"></i>
                        <h4>Contact No</h4>
                        <p>
                          <a href="tel:+02223385625">{ContactNo}</a>
                        </p>
                      </div>

                      <div className="col-md-6 mb-3">
                        <i className="fa-solid fa-envelope-circle-check"></i>
                        <h4>Email</h4>
                        <p>{EmailAdd}</p>
                        <p>rupaliinsurance@gmail.com</p>
                      </div>
                    </div>
                  </div>

                  <div className="right mb-lg-0 mb-4">
                    <h6>
                      Officials of Investor's Relation Department/Share
                      Department.
                    </h6>
                    {/* <h4>{Info[0]}</h4>
                    <p>{Info[1]} </p> */}
                    <h4>{Info[2]}</h4>
                    <p>{Info[3]}</p>
                  </div>
                </div>

                <div className="col-lg-5">
                  <img src={contactImg} className="img-fluid" alt="" />
                </div>
              </div>

              <div className="google_map">
                <div className="my-5">
                  <iframe
                    title="myFrame"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7305.013957772548!2d90.415415!3d23.729294!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6c52ef3ba320b7f0!2sRupali%20Bima%20Bhaban!5e0!3m2!1sen!2sus!4v1669187339947!5m2!1sen!2sus"
                    style={{ border: 0, height: "450px", width: "100%" }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center my-5">
              <button className="btn btn-danger w-50" type="button" disabled>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ContactUs;
